export enum SensitivityLevel {
    Low = 'Low',
    Medium = 'Medium',
    High = 'High'
}

export enum AccessLevel {
  InternalCustomerAdmin = 'InternalCustomerAdmin',
  ExternalCustomerAdmin = 'ExternalCustomerAdmin',
  PlatformOwner = 'PlatformOwner',
  SuperAdmin = 'SuperAdmin',
  SurveyAdmin = 'SurveyAdmin',
  Admin = 'Admin',
  OrgAdmin = 'OrgAdmin',
  ManagerPlus = 'ManagerPlus',
  Manager = 'Manager',
  Viewer = 'Viewer',
  Custom = 'Custom'
}
